import { OtherUserRedditPanelCSS } from './OtherUserRedditPanelCSS.styled'
import { UserRedditOverview } from 'components/Molecules/userProfileOverview/UserRedditOverview'

export const OtherUserRedditPanel = (props) => {
  return (
    <OtherUserRedditPanelCSS>
      <div className='user_tabs_wrapper'>
        <div className='user_panels'>
          <div className='sections_wrapper'>
            <div className='user_tabs_panel' id='user-overview_panel'>
              <UserRedditOverview {...props} />
            </div>
          </div>
        </div>
      </div>
    </OtherUserRedditPanelCSS>
  )
}
